export default __webpack_public_path__ + "static/3-e230e0262e79c0875a010a233ed3074c.jpeg";